export const DsIconButtonDefaultProps = {
    color: 'iconDefault'
};
